import type { Settings } from 'shared/types'
import { loadSettings } from 'loaders/settings'

class SettingsSingleton {
  private static instance: SettingsSingleton

  private settings: Settings | undefined

  private loadingPromise: Promise<Settings | undefined> | null = null

  public static getInstance(): SettingsSingleton {
    if (!SettingsSingleton.instance) {
      SettingsSingleton.instance = new SettingsSingleton()
    }
    return SettingsSingleton.instance
  }

  public async getSettings(client?: any): Promise<Settings | undefined> {
    if (this.settings) {
      return this.settings
    }
    if (!this.loadingPromise && client) {
      this.loadingPromise = loadSettings(client)().then(settings => {
        this.settings = settings
        this.loadingPromise = null
        return settings
      })
    }
    return this.loadingPromise ?? Promise.resolve(undefined)
  }
}

export default SettingsSingleton
